import { SearchResponse, PartOfSpeech, Register } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error("REACT_APP_API_BASE_URL environment variable is not set");
}

const TOKEN_KEY = 'thesaurus_auth_token';

// Helper function to get auth headers
function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return {};
  }
  return {
    'Authorization': `Bearer ${token}`,
  };
}

export interface SearchParams {
  query: string;
  part_of_speech?: PartOfSpeech;
  register?: Register;
  min_frequency?: number;
}

export const api = {
  async search(params: SearchParams): Promise<SearchResponse> {
    const queryParams = new URLSearchParams();
    queryParams.append("q", params.query);

    if (params.part_of_speech) {
      queryParams.append("part_of_speech", params.part_of_speech);
    }
    if (params.register) {
      queryParams.append("register", params.register);
    }
    if (params.min_frequency) {
      queryParams.append("min_frequency", params.min_frequency.toString());
    }

    const response = await fetch(
      `${API_BASE_URL}/search?${queryParams.toString()}`,
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status === 401) {
      // Unauthorized - clear token and reload
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/';
      throw new Error('Authentication required');
    }

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  async getWordDetails(word: string): Promise<any> {
    const response = await fetch(`${API_BASE_URL}/word/${word}`, {
      headers: getAuthHeaders(),
    });

    if (response.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/';
      throw new Error('Authentication required');
    }

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },

  async getFilters(): Promise<{
    parts_of_speech: string[];
    registers: string[];
    frequency_range: { min: number; max: number };
  }> {
    const response = await fetch(`${API_BASE_URL}/filters`, {
      headers: getAuthHeaders(),
    });

    if (response.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = '/';
      throw new Error('Authentication required');
    }

    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }

    return response.json();
  },
};